export class SortAggregationServingTokenBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "AggregationServingTokenSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortAggregationServingTokenBy.attributeTypeMap;
    }
    constructor() {
    }
}
